import { defineStore } from "pinia";
import { ref } from "vue";
import ws from '@/utils/websocket.js';


export const intervalFunStore = defineStore("intervalFunStore", () => {

  const websocketInfo = ref(null)

  const setIntervalFun = () => {

    if (websocketInfo.value) {
      websocketInfo.value.close();
      websocketInfo.value = null;
    }

    websocketInfo.value = new ws({
      onMessageCD: msg => {
        const msgData = JSON.parse(msg.data);
        const { type, logId } = msgData.data;
        if (type === 'bind' && logId) {
          window.sessionStorage.setItem('logId', logId);
        }
      }
    });
  }


  const websocketClose = () => {
    if (!websocketInfo.value) {
      return
    }
    websocketInfo.value.close(1000);
    websocketInfo.value = null;
  }


  return {
    setIntervalFun,
    websocketClose,
    websocketInfo
  };
});